import type { RouteObject } from 'react-router-dom';
import { authRoutes } from '@/features/authentication';

export const publicRoutes: RouteObject[] = [...authRoutes];
